<app-header></app-header>

<app-hero-section></app-hero-section>

<app-what-is-schema></app-what-is-schema>

<app-why-choose-us></app-why-choose-us>

<app-technologies></app-technologies>

<app-coming-soon></app-coming-soon>

<app-footer></app-footer>

<router-outlet></router-outlet>